import { render, staticRenderFns } from "./Employment.vue?vue&type=template&id=34987236&scoped=true&"
import script from "./Employment.vue?vue&type=script&lang=js&"
export * from "./Employment.vue?vue&type=script&lang=js&"
import style0 from "./Employment.vue?vue&type=style&index=0&id=34987236&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34987236",
  null
  
)

export default component.exports